import React, {useState, Component} from 'react'
import {Modal, Button} from 'react-bootstrap'
import IntlMessages from '../../helpers/IntlMessages';
import ReactPlayer from 'react-player';
import './style.css'
import { Stream } from "@cloudflare/stream-react";
import { PDFObject } from 'react-pdfobject';

 class SessionModal extends Component {


  closeModal(){
    this.props.closeModalHandler()

  }

  createMarkup(text){
    return {__html : text }
  }

  render(){
    const {show,url,title,mode} = this.props
    return (
      <>
        <Modal dialogClassName="sessionVideoModalDialog"
        show={show}
        onHide={() => this.closeModal()}
        id="SessionModal"
        >
           <Modal.Header className="videoModalHeader"  closeButton>
             <h2>
              <div className="sessionModalTitle" dangerouslySetInnerHTML={this.createMarkup(title)}>
                
              </div>
            </h2>
           </Modal.Header>     
            <Modal.Body className="sessionVideoModalBody">
            {
              mode == "video"?
                url.match("cloudflare")!= null?
                <Stream controls src={url} />
                :
                url.match("vimeo") || url.match("videodelivery.net")!= null?
                <iframe width="100%" height="100%"  src={url} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen="allowfullscreen"></iframe>
                :
                <ReactPlayer
                      width="100%" 
                      height="100%" 
                      url={url}
                      controls={true}
                  />
              :
            <PDFObject 
               url= {url} 
               forcePDFJS={true}
               />
          } 
          </Modal.Body>
          <Modal.Footer>
            {/* <Button color="primary">
              Do Something
            </Button> */}
            {' '}
            <Button
              color="primary"
              onClick={() => this.closeModal()}
            >
              <IntlMessages id="dashboards.staticPage-back"/>
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
}}

export default SessionModal